<template>
  <div id="contenedor-configuracion-firmas-mobile">
    <v-list>
      <template v-if="listado.length">
        <template v-for="(firma, index) in listado">
          <v-list-item
            :key="firma.id"
            three-line
            class="px-0">
            <v-list-item-content>
              <div class="d-flex align-center mb-1">
                <v-chip
                  small
                  color="primary"
                  text-color="white"
                  class="mr-2 font-weight-bold">
                  Orden de firma {{ firma.orden }}
                </v-chip>
                <v-list-item-title class="font-weight-medium">
                  {{ firma.funcionario.nombre }}
                </v-list-item-title>
              </div>
              <v-list-item-subtitle class="mb-1">
                {{ firma.funcionario.puesto || 'Sin puesto asignado' }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Nombramiento: {{ formatoFecha(firma.funcionario.fechaNombramiento) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Registro:
                <fecha-humano
                  class="ml-1"
                  :fecha="firma.createdAt">
                </fecha-humano>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                icon
                color="error"
                @click="$emit('eliminar', firma)">
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider
            v-if="index < listado.length - 1"
            :key="`mobile-divider-${firma.id}`">
          </v-divider>
        </template>
      </template>
      <v-list-item v-else>
        <v-list-item-content>
          <v-list-item-title>
            No hay firmantes registrados.
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'ConfiguracionFirmasMobile',
  components: {
    FechaHumano,
  },
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatoFecha(fecha) {
      if (!fecha) return 'Sin fecha';
      return this.$moment(fecha).format('DD/MM/YYYY');
    },
  },
};
</script>

<style lang="scss">

</style>
